<template>
  <div>
    <div class="level">
      <div class="level-left">
        <router-link :to="{name: 'Create Leave'}" class="button is-small is-info">
          <span class="icon">
            <i class="fas fa-plus"></i>
          </span>&nbsp; Create new</router-link>
        &nbsp;
        <button class="button is-small" @click="refreshTable()">Refresh</button>
      </div>
      <div class="level-right">
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
    </div>
    <table-pagination :tableData="leaves.data" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true" :loading="isLoadingTable" :page="page" :perPage="perPage" :totalData="leaves.totalData" @onPageChanged="page = $event" @onSearchChanged="search = $event" @onPerPageChanged="perPage = $event">
      <template slot="row-content" slot-scope="{item}">
        <b-table-column field="leaveId" class="table-column-content-is-small" label="Leave #">
          {{item.row.leaveId}}
        </b-table-column>
        <b-table-column field="employeeName" class="table-column-content-is-small" label="Employee">
          {{item.row.employeeName}}
        </b-table-column>
        <b-table-column field="payrollPeriod" class="table-column-content-is-small" label="Payroll Period">
          {{item.row.payrollPeriod}}
        </b-table-column>
        <b-table-column field="isPaid" class="table-column-content-is-small" label="Is Paid?">
          <span v-if="item.row.isPaid">Yes</span>
          <span v-else>No</span>
        </b-table-column>
        <b-table-column field="totalDays" class="table-column-content-is-small" label="Total Days">
          {{item.row.totalDays}}
        </b-table-column>
        <b-table-column field="approvedBy" class="table-column-content-is-small" label="Approved By">
          {{item.row.approvedBy}}
        </b-table-column>
        <b-table-column field="status" class="table-column-content-is-small" label="Status">
          {{item.row.status}}
        </b-table-column>
        <b-table-column field="" class="table-column-content-is-small" label="">
          <router-link :to="{name: 'Edit Leave', params: {'leaveId': item.row.leaveId}}" class="button is-warning is-small">Edit</router-link>
          &nbsp;
          <button class="button is-danger is-small" @click="deleteLeave(item.row.leaveId)">Delete</button>
          <span v-if="!item.row.approvedBy || item.row.status === 'Pending'">
            &nbsp;
            <button :class="resendButton" @click="resendToEmployeeSupervisor(item.row.leaveId)" alt="Resend to employee supervisor">Resend</button>
          </span>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large">
              </b-icon>
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </table-pagination>
    <delete-modal/>
  </div>
</template>

<script>
import TablePagination from '../TablePagination.vue'
import { mapState, mapActions } from 'vuex'
import DeleteModal from './Delete.vue'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'
import axios from 'axios'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      isEmpty: false,
      page: 1,
      perPage: 10,
      search: '',
      resendButton: appButton.isLoadingNormal(false)
    }
  },
  computed: {
    ...mapState('leave', {
      isLoadingTable: state => state.isLoadingTable,
      leaves: state => state.leaves,
      showDeleteModal: state => state.showDeleteModal
    })
  },
  components: {
    tablePagination: TablePagination,
    deleteModal: DeleteModal
  },
  mounted() {
    this.default()
  },
  methods: {
    ...mapActions('leave', ['getPaginatedLeaves', 'openDeleteModal']),
    default() {
      this.getPaginatedLeaves({
        page: this.page,
        pageSize: this.perPage,
        query: this.search
      })
    },
    refreshTable() {
      this.default()
    },
    resendToEmployeeSupervisor(leaveId) {
      if (leaveId) {
        this.resendButton = appButton.isLoadingNormal(true)
        axios
          .post(`api/leaves/resendnotificationtosupervisor/${leaveId}`)
          .then(response => {
            appToast.success(response.data)
          })
          .catch(error => {
            console.log(error)
            appToast.danger(error.response.data)
          })
          .then(() => {
            this.resendButton = appButton.isLoadingNormal(false)
            this.default()
          })
      }
    },
    deleteLeave(leaveId) {
      this.openDeleteModal({
        showDeleteModal: true,
        leave: {
          leaveId: leaveId
        }
      })
    }
  },
  watch: {
    perPage(val) {
      this.getPaginatedLeaves({
        page: this.page,
        pageSize: val,
        query: this.search
      })
    },
    page(val) {
      this.getPaginatedLeaves({
        page: val,
        pageSize: this.perPage,
        query: this.search
      })
    },
    search(val) {
      this.getPaginatedLeaves({
        page: this.page,
        pageSize: this.perPage,
        query: val
      })
    },
    showDeleteModal() {
      this.default()
    }
  }
}
</script>
